module.exports = __webpack_public_path__ + "static/img/Rome-Burgoyne.92fb7d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rome-Burgoyne.jpg
// module id = OEC8
// module chunks = 0